export default __webpack_public_path__ + "static/context-dont-4-3a717f1f7b9bb5a3ef6a4f0e15d52721.png";